<template>
    <div>
        <v-menu
                v-model="menuModel"
                :open-on-click="false"
                open-on-hover
                @input="resetCopyState"
                :close-on-content-click="false"
                content-class="app-bar-form-editor-form-published-popup"
                offset-y
                bottom
        >
            <template #activator="{on}">
                <div
                        v-on="shareFormVisible ? {} : on"
                >
                    <v-btn
                            rounded
                            disabled
                    >
                        Published
                    </v-btn>
                </div>
            </template>
            <template>
                <v-card class="app-bar-form-editor-form-published-popup__card">
                    <v-card-title class="app-bar-form-editor-form-published-popup__card-title">
                        Get the link
                    </v-card-title>
                   
                    <v-card-text class="app-bar-form-editor-form-published-popup__card-body">
                        <div class="app-bar-form-editor-form-published-popup__card-body-main">
                            <div class="card-link-published">
                                <span ref="linkText" class="link-text" @click="openLink">
                                    {{ submitLink }}
                                </span>
                                <v-btn fab icon @click="copyLink" class="copy-btn">
                                    <CopyIcon/>
                                </v-btn>
                            </div>
                            <div v-if="copied" class="copied-hint">Copied!</div>
                        </div>
                        <div class="app-bar-form-editor-form-published-popup__card-body-subtitle">
                            Or share with:
                        </div>
                        <div class="app-bar-form-editor-form-published-popup__card-body-actions">
                            <v-btn v-for="(item, index) in shareIcons"
                                   :key="index"
                                   :href="item.URL"
                                   target="_blank"
                                   class="app-bar-form-editor-form-published-popup__card-body-social-btn"
                                   icon
                                   small
                            >
                                <v-icon size="28">
                                    {{ item.icon }}
                                </v-icon>
                            </v-btn>
                            <v-btn 
                                @click="showQRModal"
                                class="app-bar-form-editor-form-published-popup__card-body-qr-btn"
                                icon
                                small
                            >
                            <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.5156 17.7188H18.1406C17.9076 17.7188 17.7188 17.9076 17.7188 18.1406V21.5156C17.7188 21.7486 17.9076 21.9375 18.1406 21.9375H21.5156C21.7486 21.9375 21.9375 21.7486 21.9375 21.5156V18.1406C21.9375 17.9076 21.7486 17.7188 21.5156 17.7188Z" fill="black"/>
                                <path d="M17.2969 14.3438H14.7656C14.5326 14.3438 14.3438 14.5326 14.3438 14.7656V17.2969C14.3438 17.5299 14.5326 17.7188 14.7656 17.7188H17.2969C17.5299 17.7188 17.7188 17.5299 17.7188 17.2969V14.7656C17.7188 14.5326 17.5299 14.3438 17.2969 14.3438Z" fill="black"/>
                                <path d="M24.8906 21.9375H22.3594C22.1264 21.9375 21.9375 22.1264 21.9375 22.3594V24.8906C21.9375 25.1236 22.1264 25.3125 22.3594 25.3125H24.8906C25.1236 25.3125 25.3125 25.1236 25.3125 24.8906V22.3594C25.3125 22.1264 25.1236 21.9375 24.8906 21.9375Z" fill="black"/>
                                <path d="M24.8906 14.3438H23.2031C22.9701 14.3438 22.7812 14.5326 22.7812 14.7656V16.4531C22.7812 16.6861 22.9701 16.875 23.2031 16.875H24.8906C25.1236 16.875 25.3125 16.6861 25.3125 16.4531V14.7656C25.3125 14.5326 25.1236 14.3438 24.8906 14.3438Z" fill="black"/>
                                <path d="M16.4531 22.7812H14.7656C14.5326 22.7812 14.3438 22.9701 14.3438 23.2031V24.8906C14.3438 25.1236 14.5326 25.3125 14.7656 25.3125H16.4531C16.6861 25.3125 16.875 25.1236 16.875 24.8906V23.2031C16.875 22.9701 16.6861 22.7812 16.4531 22.7812Z" fill="black"/>
                                <path d="M23.625 1.6875H16.0312C15.5837 1.6875 15.1545 1.86529 14.838 2.18176C14.5215 2.49822 14.3438 2.92745 14.3438 3.375V10.9688C14.3438 11.4163 14.5215 11.8455 14.838 12.162C15.1545 12.4785 15.5837 12.6562 16.0312 12.6562H23.625C24.0726 12.6562 24.5018 12.4785 24.8182 12.162C25.1347 11.8455 25.3125 11.4163 25.3125 10.9688V3.375C25.3125 2.92745 25.1347 2.49822 24.8182 2.18176C24.5018 1.86529 24.0726 1.6875 23.625 1.6875ZM21.9375 8.85938C21.9375 8.97126 21.8931 9.07857 21.8139 9.15769C21.7348 9.2368 21.6275 9.28125 21.5156 9.28125H18.1406C18.0287 9.28125 17.9214 9.2368 17.8423 9.15769C17.7632 9.07857 17.7188 8.97126 17.7188 8.85938V5.48438C17.7188 5.37249 17.7632 5.26518 17.8423 5.18606C17.9214 5.10695 18.0287 5.0625 18.1406 5.0625H21.5156C21.6275 5.0625 21.7348 5.10695 21.8139 5.18606C21.8931 5.26518 21.9375 5.37249 21.9375 5.48438V8.85938ZM10.9688 1.6875H3.375C2.92745 1.6875 2.49822 1.86529 2.18176 2.18176C1.86529 2.49822 1.6875 2.92745 1.6875 3.375V10.9688C1.6875 11.4163 1.86529 11.8455 2.18176 12.162C2.49822 12.4785 2.92745 12.6562 3.375 12.6562H10.9688C11.4163 12.6562 11.8455 12.4785 12.162 12.162C12.4785 11.8455 12.6562 11.4163 12.6562 10.9688V3.375C12.6562 2.92745 12.4785 2.49822 12.162 2.18176C11.8455 1.86529 11.4163 1.6875 10.9688 1.6875ZM9.28125 8.85938C9.28125 8.97126 9.2368 9.07857 9.15769 9.15769C9.07857 9.2368 8.97126 9.28125 8.85938 9.28125H5.48438C5.37249 9.28125 5.26518 9.2368 5.18606 9.15769C5.10695 9.07857 5.0625 8.97126 5.0625 8.85938V5.48438C5.0625 5.37249 5.10695 5.26518 5.18606 5.18606C5.26518 5.10695 5.37249 5.0625 5.48438 5.0625H8.85938C8.97126 5.0625 9.07857 5.10695 9.15769 5.18606C9.2368 5.26518 9.28125 5.37249 9.28125 5.48438V8.85938ZM10.9688 14.3438H3.375C2.92745 14.3438 2.49822 14.5215 2.18176 14.838C1.86529 15.1545 1.6875 15.5837 1.6875 16.0312V23.625C1.6875 24.0726 1.86529 24.5018 2.18176 24.8182C2.49822 25.1347 2.92745 25.3125 3.375 25.3125H10.9688C11.4163 25.3125 11.8455 25.1347 12.162 24.8182C12.4785 24.5018 12.6562 24.0726 12.6562 23.625V16.0312C12.6562 15.5837 12.4785 15.1545 12.162 14.838C11.8455 14.5215 11.4163 14.3438 10.9688 14.3438ZM9.28125 21.5156C9.28125 21.6275 9.2368 21.7348 9.15769 21.8139C9.07857 21.8931 8.97126 21.9375 8.85938 21.9375H5.48438C5.37249 21.9375 5.26518 21.8931 5.18606 21.8139C5.10695 21.7348 5.0625 21.6275 5.0625 21.5156V18.1406C5.0625 18.0287 5.10695 17.9214 5.18606 17.8423C5.26518 17.7632 5.37249 17.7188 5.48438 17.7188H8.85938C8.97126 17.7188 9.07857 17.7632 9.15769 17.8423C9.2368 17.9214 9.28125 18.0287 9.28125 18.1406V21.5156Z" fill="black"/>
                            </svg>

                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </template>
        </v-menu>

        <!-- QR Code Modal Component -->
        <QRCodeModal 
            v-model="qrModalVisible" 
            :share-link="submitLink" 
        />
    </div>
</template>

<script>
    import {mapGetters} from '@/xstore'
    import QRCodeModal from '@/components/Elements/QRCodeModal'

    export default {
        name: "LockedPublishButton",
        components: {
            QRCodeModal,
            CopyIcon: () => import('vue-feather-icons/icons/CopyIcon'),
        },
        props: {
            shareFormVisible: Boolean
        },
        data: () => ({
            menuModel: false,
            copied: false,
            qrModalVisible: false,
        }),
        computed: {
            ...mapGetters('edit', [
                'getFormDBData',
            ]),
            ...mapGetters('edit/publish', [
                'isPublishedFormWasChanged'
            ]),
            submitLink() {
                if (this.getFormDBData?.id)
                    return window.location.origin + this.$router.resolve({
                        name: this.constants.PAGE_NAME_FORM_SUBMIT,
                        params: {formId: this.getFormDBData.id}
                    }).href
                return ''
            },
            shareIcons() {
                if (!this.submitLink) return []
                
                const encodedURIComponentURL = window.encodeURIComponent(`${this.submitLink}`)
                return [
                    {
                        icon: '$twitter',
                        URL: `https://twitter.com/intent/tweet?url=${encodedURIComponentURL}`,
                    },
                    {
                        icon: '$whatsapp',
                        URL: `https://api.whatsapp.com/send?text=${encodedURIComponentURL}`
                    },
                    {
                        icon: '$telegram',
                        URL: `https://t.me/share/url?url=${encodedURIComponentURL}`
                    },
                ]
            }
        },
        watch: {
            isPublishedFormWasChanged(v) {
                if (v)
                    this.menuModel = false
            },
            menuModel(v) {
                if (!v) {
                    this.resetCopyState()
                }
            }
        },
        methods: {
            onCopy() {
                this.copied = true
                setTimeout(() => {
                    this.copied = false
                }, 2000)
            },
            copyLink() {
                const range = new Range()
                range.selectNodeContents(this.$refs.linkText);
                const getSel = window.getSelection()
                getSel.removeAllRanges();
                getSel.addRange(range);
                document.execCommand('copy');
                getSel.removeAllRanges();
                this.copied = true;
                setTimeout(() => {
                    this.copied = false
                }, 2000)
            },
            copy() {
                const range = new Range()
                range.selectNodeContents(this.$refs.publishedLink);
                const getSel = window.getSelection()
                getSel.removeAllRanges();
                getSel.addRange(range);
                document.execCommand('copy');
                getSel.removeAllRanges();
                this.copied = true;
            },
            resetCopyState() {
                this.copied = false
            },
            openLink() {
                window.open(this.submitLink, '_blank')
            },
            showQRModal() {
                this.qrModalVisible = true
            }
        }
    }
</script>

<style lang="scss">
    .app-bar-form-editor-form-published-popup {
        
        &__card {
            padding: 0 !important;
        }

        width: 381px;
        &__card-title {
            color: var(--v-gray_500-base);
            font-size: 18px;
            padding-bottom: 8px;
            font-weight: 500;
        }

        &__card-body {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }

        &__card-body-main {
            display: flex;
            gap: 15px;
            align-items: center;
        }

        .link-text {
            display: block;
            color: #3D66F6;
            width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 13px;
            cursor: pointer;
        }

        .copy-btn {
            width: 20px !important;
            height: 20px !important;
            
            .v-icon {
                color: #666 !important;
                font-size: 18px !important;
            }
        }

        .copied-hint {
            font-size: 12px;
            color: #4CAF50;
            margin-top: 4px;
        }

        &__card-body-subtitle {
            color: var(--v-gray_500-base);
            font-size: 14px;
            margin-bottom: -5px;
        }

        &__card-body-actions {
            display: flex;
            gap: 8px;
            align-items: center;
        }

        &__card-body-social-btn,
        &__card-body-qr-btn {
            min-width: 32px !important;
            border-radius: 6px !important;
            
            &:hover {
                background-color: #e0e0e0 !important;
            }
            
            .v-icon {
                color: #666 !important;
            }
            
            svg {
                fill: #666;
            }
        }

        &__card-body-qr-btn {
            svg {
                width: 30px;
                height: 30px;
            }
        }
    }

    .card-link-published {
        display: flex;
        align-items: center;
        gap: 10px;
        border: 1px solid #D2D5DC;
        border-radius: 8px;
        padding: 10px 12px;
        font-size: 16px;
        font-weight: 500;
    }
</style>